import { Button, FormControl, TextField, InputLabel } from '@mui/material';
import React, { useState, useEffect } from 'react';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import styles from './styles';

interface IOwnProps {
  label?: string;
  required?: boolean;
  type?: string;
  minValue?: number;
  maxValue?: number;
  initialValue?: number;
  onIncrement?: () => void;
  onDecrement?: () => void;
}

const ButtonCounter: React.FC<any> = (props) => (
  <Button variant="outlined" {...props}>
    {props.children}
  </Button>
);

const InputCounter: React.FC<IOwnProps> = ({
  label,
  required = false,
  minValue = 0,
  maxValue,
  initialValue = 0,
  onIncrement = () => {},
  onDecrement = () => {},
}) => {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const handleIncrement = () => {
    if ((maxValue && value < maxValue) || !maxValue) {
      setValue((prev) => prev + 1);
      onIncrement();
    }
  };

  const handleDecrement = () => {
    if ((minValue && value > minValue) || (!minValue && value > 0)) {
      setValue((prev) => prev - 1);
      onDecrement();
    }
  };

  return (
    <FormControl className="counterRoot" sx={styles}>
      <InputLabel className="counterLabel">
        {label} {required && '*'}
      </InputLabel>
      <ButtonCounter className="buttonCounter" onClick={handleDecrement}>
        <RemoveIcon />
      </ButtonCounter>
      <TextField
        value={value}
        required={required}
        className="counterTextField"
        InputProps={{
          classes: {
            input: 'textFieldCounter',
          },
        }}
        InputLabelProps={{
          classes: {
            root: 'textFieldLabel',
          },
        }}
        variant="filled"
      />
      <ButtonCounter className="buttonCounter" onClick={handleIncrement}>
        <AddIcon />
      </ButtonCounter>
    </FormControl>
  );
};

export default InputCounter;
